import { createFileRoute } from '@tanstack/react-router'

import { PublicHomePage } from '~/boundedContext/home/pages/public-home-page'

export const Route = createFileRoute('/')({
  component: PublicHomePage,
})
